import { render, staticRenderFns } from "./ItemPicturesCarousel.vue?vue&type=template&id=23205aa0&scoped=true&"
import script from "./ItemPicturesCarousel.vue?vue&type=script&lang=js&"
export * from "./ItemPicturesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ItemPicturesCarousel.vue?vue&type=style&index=0&id=23205aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23205aa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCarousel,VCarouselItem,VDialog,VSheet})
